// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"da097d19","160":"28d844c0","453":"130d29ad","558":"83a95f1a"}[chunkId] + ".chunk.js";
};